import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


const query = gql`
    query assetPrimaryImage($organizationId: UUID!, $assetId: UUID!) {
        assetImage(organizationId: $organizationId,  assetId: $assetId)        
    }
    `;

export function apiGetAssetPrimaryImage(organizationId, assetId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        if(!assetId) reject("assetId is required");
        client
            .query({
                query: query,
                variables: {organizationId, assetId},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.assetPrimaryImage);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get image");
                reject(err); // R
            })
    });
}
